/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubMenu } from '../../models/sub-menu';
import { SubMenuApiRespModel } from '../../models/sub-menu-api-resp-model';

export interface ApiMasterSubMenuAddPost$Params {
      body?: SubMenu
}

export function apiMasterSubMenuAddPost(http: HttpClient, rootUrl: string, params?: ApiMasterSubMenuAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<SubMenuApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterSubMenuAddPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SubMenuApiRespModel>;
    })
  );
}

apiMasterSubMenuAddPost.PATH = '/api/Master/SubMenu/Add';
